/*
 * @Editor: chenqy
 * @Description: 类似html标签中的title属性 弹出窗功能，但能自定义样式。
 *
 * ============== 使用方法 ===============
 * 1、默认样式(白色主题)： v-title="'你的内容'"
 * 2、切换样式(黑色)： v-title="{content:'你的内容', theme: 'dark'}"
 * 3、若需要特殊的样式请使用该方式： v-title="{content:'你的内容', className: '你的样式'}"
 *
 * @Date: 2023-09-01 10:05:47
 * @LastEditors: Chenqy
 * @LastEditTime: 2025-01-20 14:05:24
 */
let moveFn = function (e, el) {
  e.stopPropagation();
  el.__vTitleIsHidden || createElement(e, el);
};
let leaveFn = function (e, el) {
  e.stopPropagation();
  clearTimeout(el.__vTitleTimer);
  el.__vTitleIsHidden = false;
  document.querySelector(".ds-popover-content")?.remove();
};
let downFn = function (e, el) {
  e.stopPropagation();
  if (!el.__vTitleIsHidden) {
    el.__vTitleIsHidden = true;
    clearTimeout(el.__vTitleTimer);
    document.querySelector(".ds-popover-content")?.remove();
  }
};

/**
 * @description:
 * el.__vueDirectiveTitleOption__ = {content, className, theme}
 * content: String：展示的内容
 * className: String：自定义弹窗样式
 * theme: String：主题(light/dark)
 * @param e {Event} 事件对象
 * @param el {HTMLElement} 事件对象
 * @return
 */
function createElement(e, el) {
  el.__vTitleCursorPosition = [e.pageX, e.pageY];
  clearTimeout(el.__vTitleTimer);
  // 为了提高性能和防止误触发，延迟500ms执行tooltip弹窗
  el.__vTitleTimer = setTimeout(() => {
    let { content, className, theme = "light" } = el.__vueDirectiveTitleOption__;

    let node = document.createElement("div");
    document.querySelector(`.ds-popover-content`)?.remove?.();
    node.innerText = content;
    // node.style.opacity = 0;
    let attrs = {
      class: className ? `${className} ds-popover-content ds-popover-content-${theme}` : `ds-popover-content ds-popover-content-${theme}`,
      id: `ds-popover-${el.__uuid}`
    };
    Object.keys(attrs).forEach((k) => {
      node.setAttribute(k, attrs[k]);
    });

    document.body.appendChild(node);
    const [pageX, pageY] = el.__vTitleCursorPosition;
    // 箭头
    let arrow = document.createElement("div");

    // 计算位置
    const { width, height } = node.getBoundingClientRect();
    // 可视窗口尺寸
    const viewHeight = window.innerHeight;
    const viewWidth = window.innerWidth;
    // 上下方向判断
    if (viewHeight - pageY - height - 10 > 0) {
      // 下
      node.style.top = `${pageY + 20}px`;
      arrow.className = "ds-popover-content-arrow ds-popover-content-arrow__bottom";
    } else {
      // 上
      node.style.top = `${pageY - height - 20}px`;
      arrow.className = "ds-popover-content-arrow ds-popover-content-arrow__top";
    }
    // 左右方向判断(位置尽量居中)
    const cursorLeft = pageX; // 当前鼠标离可视区左边距离
    const cursorRight = viewWidth - pageX; // 当前鼠标离可视区左边距离
    const nodeHalfWidth = width / 2;
    let nodeLeft = 0;
    let arrowOffsetX = 0;
    const gap = 10; // 边缘部分间隙
    // 右方向优先
    if (cursorRight > width) {
      if (nodeHalfWidth < cursorLeft) {
        nodeLeft = pageX - nodeHalfWidth;
        arrowOffsetX = "50%";
      } else {
        nodeLeft = pageX - cursorLeft + gap;
        arrowOffsetX = `${cursorLeft}px`;
      }
    } else {
      if (nodeHalfWidth < cursorRight) {
        nodeLeft = pageX - nodeHalfWidth;
        arrowOffsetX = "50%";
      } else {
        nodeLeft = pageX - width + cursorRight - gap;
        arrowOffsetX = `calc(100% - ${cursorRight}px)`;
      }
    }
    node.style.left = `${nodeLeft}px`;
    arrow.style.left = arrowOffsetX;
    node.appendChild(arrow);
  }, 500);
}
// 标准化数据
function handleDataFormatter(data) {
  let content = dsf.isObject(data) ? data?.content || "" : data + "";
  let className = data?.className;
  let theme = data?.theme;
  return {
    content,
    className,
    theme
  };
}
export default {
  bind: function (el, { value }) {
    el.__vTitleTimer = null;
    el.__vTitleIsHidden = false; // 关闭弹窗
    el.__vTitleCursorPosition = [];
    el.__uuid = dsf.uuid();
    let data = handleDataFormatter(value);
    el.__vueDirectiveTitleOption__ = data;
    el.__moveFn = (e) => moveFn(e, el);
    el.__leaveFn = (e) => leaveFn(e, el);
    el.__downFn = (e) => downFn(e, el);
    el.addEventListener("mousemove", el.__moveFn);
    el.addEventListener("mouseout", el.__leaveFn);
    el.addEventListener("mousedown", el.__downFn);
  },
  update: function (el, { value }, vnode) {
    const currentOption = _.filter(vnode.data.directives, (item) => item.name === "title")[0];
    if (JSON.stringify(currentOption.oldValue) !== JSON.stringify(currentOption.value)) {
      el.removeEventListener("mousemove", el.__moveFn);
      const data = handleDataFormatter(value);
      el.__vueDirectiveTitleOption__ = data;
      el.addEventListener("mousemove", el.__moveFn);
    }
  },
  unbind: function (el) {
    if (el.__uuid) {
      const ele = document.querySelector(`#ds-popover-${el.__uuid}`);
      if (ele) {
        ele.remove();
      }
    }
    clearTimeout(el.__vTitleTimer);
    el.__vueDirectiveTitleOption__ = null;
    el.removeEventListener("mousemove", el.__moveFn);
    el.removeEventListener("mouseout", el.__leaveFn);
    el.removeEventListener("mousedown", el.__downFn);
  },
  install(Vue) {
    Vue.directive("title", {
      bind: this.bind,
      unbind: this.unbind,
      update: this.update
    });
  }
};
